const deviceType = {
    ANDROID: "android",
    IOS: "ios"
};

export default deviceType;
